import { ACCESS_PROFILE, EJARI_USER, RDC_USER } from "./roles";
import { UserSource } from "./source";
import { BaseProfile, IProfile } from "./profiles";
import { getUser } from "./index";

export interface IEjariProfile extends IProfile {
	Identity: number;
	UserName: string;
	FirstName: string;
	ParticipantNameEn: string;
	ParticipantNameAr: string;
	UserTypeId: number;
	FacilityUserTypeId: number;
	Mobile?: string;
	Email: string;
	ParticipantId: number;
	EjariUserTypeId: number;
	RdcRoleId: number;
	TenantNumber: string;
}

export class EjariProfile extends BaseProfile implements IEjariProfile {
	Identity: number;
	UserName: string;
	FirstName: string;
	ParticipantNameEn: string;
	ParticipantNameAr: string;
	UserTypeId: number;
	FacilityUserTypeId: number;
	Mobile?: string;
	Email: string;
	ParticipantId: number;
	EjariUserTypeId: number;
	RdcRoleId: number;
	TenantNumber: string;

	constructor( profile: IEjariProfile ) {
		super( UserSource.EJARI, profile.ParticipantId );
		this.Identity = profile.Identity;
		this.UserName = profile.UserName;
		this.FirstName = profile.FirstName;
		this.ParticipantNameEn = profile.ParticipantNameEn;
		this.ParticipantNameAr = profile.ParticipantNameAr;
		this.UserTypeId = profile.UserTypeId;
		this.FacilityUserTypeId = profile.FacilityUserTypeId;
		this.Mobile = profile.Mobile ? profile.Mobile.replace( /[^\d]/g, "" ) : undefined;
		this.Email = profile.Email;
		this.ParticipantId = profile.ParticipantId;
		this.EjariUserTypeId = profile.EjariUserTypeId;
		this.RdcRoleId = profile.RdcRoleId;
		this.TenantNumber = profile.TenantNumber;
		this.refreshRoles();
	}

	static buildProfile( profile: IEjariProfile ): EjariProfile {
		const p = new EjariProfile( profile );
		return p;
	}

	static getProfile(): EjariProfile | undefined {
		const u = getUser();
		if ( u )
			return u.getProfile( UserSource.EJARI ) as EjariProfile;
		return undefined;
	}

	refreshRoles() {
		super.refreshRoles();
		if ( !this.hasRole( EJARI_USER ) ) this.addRole( RDC_USER );
		if ( !this.hasRole( ACCESS_PROFILE ) ) this.addRole( ACCESS_PROFILE );
	}

}
